import Vue from "vue";
import Vuex from "vuex";
import _package from "../../package.json";
import serialize from "../utils/serialize";

Vue.use(Vuex);

const serverURL = _package.server[process.env.NODE_ENV] || "http://192.168.0.200:5000";

export default {
  namespaced: true,
  state: {
    path: "/api/v2/telegram/director",
  },
  actions: {
    employees({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/employees-salarys?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    updateEmployeeSalary({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-employee-salary`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    vedomestGetAll({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/vedomest-get-all`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    confirmVedomest({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/confirm-vedomest`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    companies({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/companies?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    branches({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/branches?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    staffers({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/staffers?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    payments({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/payments?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    paymentsByDates({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/payments-by-dates?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    confirmPayments({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/confirm-payments`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    spendings({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/spendings?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    reports({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/reports?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    groups({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/groups?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getDebts({ dispatch, state, rootState }, options) {
      console.log("getDebts store", options);

      return dispatch(
        "FETCH",
        {
          url: `${state.path}/debts?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    couresPrices({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/courses-prices?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addCoursePrice({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-course-price`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    updateCoursePrice({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-course-price`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
